module.exports = __webpack_public_path__ + "static/media/login-illustration.60e77202.svg";